import {
  PATH_NAME_PAID, PATH_NAME_POOQZONE_PRIVACY,
  PATH_NAME_POOQZONE_VOUCHER,
  PATH_NAME_PRIVACY,
  PATH_NAME_SERVICE,
  PATH_NAME_YOUTH
} from '@/common/router.const'
import { STORAGE_ROUTER_HISTORY } from '@/common/resources/const'
import { parseUrl } from 'query-string'
import { get } from 'lodash'

const ROUTE_HISTORY_SIZE = 5

export function agreementRedirect (to) {
  if (to.query.category === 'payment' || to.query.category === 'paid') {
    return { name: PATH_NAME_PAID }
  } else if (to.query.category === 'service') {
    return { name: PATH_NAME_SERVICE }
  } else if (to.query.category === 'privacy') {
    return { name: PATH_NAME_PRIVACY }
  } else if (to.query.category === 'youth') {
    return { name: PATH_NAME_YOUTH }
  } else if (to.query.category === 'pooqzone') {
    return { name: PATH_NAME_POOQZONE_VOUCHER }
  } else if (to.query.category === 'pooqzone_privacy') {
    return { name: PATH_NAME_POOQZONE_PRIVACY }
  } else {
    return { name: PATH_NAME_SERVICE }
  }
}

/**
 *
 * to 객체를 받아 session storage 에 router history 를 저장한다.
 * session Storage 에 [0,1,2,3,4] 0번 (현재 url) 부터 히스토리가 순차적으로 queue 에 쌓인다.
 * @param to
 */
export const setRouteHistory = (to) => {
  const path = get(to, 'fullPath', '')
  const routerHistoryArray = JSON.parse(sessionStorage.getItem(STORAGE_ROUTER_HISTORY)) || []
  const pathQueueNewestRouter = parseUrl(get(routerHistoryArray, '0.url', ''))
  const pathCurrentRouter = get(to, 'path', '')

  if (pathQueueNewestRouter === pathCurrentRouter) {
    routerHistoryArray.shift()
  }

  if (routerHistoryArray.length >= ROUTE_HISTORY_SIZE) {
    routerHistoryArray.pop()
  }

  routerHistoryArray.unshift(path)
  sessionStorage.setItem(STORAGE_ROUTER_HISTORY, JSON.stringify(routerHistoryArray))
}
